import { translate } from './translation';

export const formatPrice = (amount) => {
    const number = new Intl.NumberFormat(document.documentElement.lang || undefined, { maximumFractionDigits: 2 }).format(amount);
    return [translate('currency.prefix'), number, translate('currency.suffix')].map(part => part.trim()).filter(Boolean).join(' ');
};
